import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './trendChip.module.scss';
import { TRENDING_STATUS } from '../constants';

export default function TrendChip({
  text,
  percentageStatus = TRENDING_STATUS.NEUTRAL,
  icon = 'icon-flechaarriba',
  className = '',
  invertColors = false,
  ...rest
}) {
  const trendChipClass = {
    [TRENDING_STATUS.NEUTRAL]: styles.neutralTrending,
    [TRENDING_STATUS.POSITIVE]: invertColors
      ? styles.negativeTrending
      : styles.positiveTrending,
    [TRENDING_STATUS.NEGATIVE]: invertColors
      ? styles.positiveTrending
      : styles.negativeTrending,
  };
  const containerClassNames = `${styles.trendChip} ${trendChipClass[percentageStatus]} ${className}`;

  return (
    <Box className={containerClassNames} {...rest}>
      {percentageStatus === TRENDING_STATUS.NEUTRAL ? (
        <>
          <Icon icon="icon-mostrarmenos" className={styles.trendChipIcon} />
          <Text className={styles.trendChipText}> % </Text>
        </>
      ) : (
        <>
          <Icon icon={icon} className={styles.trendChipIcon} />
          <Text className={styles.trendChipText}> {text} </Text>
        </>
      )}
    </Box>
  );
}
